import type { ReactNode } from "react";
import { cn } from "../../lib/utils.js";

export const TECHNICAL_VALUE_DIR = "ltr" as const;

const isolateClassName = "[unicode-bidi:isolate]";
const plaintextClassName = "[unicode-bidi:plaintext]";

export function TechnicalValue({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}): React.JSX.Element {
  return (
    <span dir={TECHNICAL_VALUE_DIR} className={cn(isolateClassName, className)}>
      {children}
    </span>
  );
}

export function MixedLocaleValue({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}): React.JSX.Element {
  return (
    <span dir="auto" className={cn(plaintextClassName, className)}>
      {children}
    </span>
  );
}
